// extracted by mini-css-extract-plugin
export default {"link":"styles_link__QZkSC","link__bold":"styles_link__bold__mKKVt","active":"styles_active__Mvp6c"};